import { createSlice,PayloadAction } from "@reduxjs/toolkit";
import { Role } from "../../types/roles";
import { TabGetConfiguration } from "../../types/navBar";

interface Rootstate{
    roles:Role[],
    status:'idle'|'loading'|'succeeded'|'failed',
    error:string | null,
    tabconfiguration:TabGetConfiguration[]

}

const initialState: Rootstate={
    roles:[],
    status:'idle',
    error:null,
    tabconfiguration:[]
}

export const rolesSlice = createSlice({
name:'roles',
initialState,
reducers:{
    setrole:(state,action:PayloadAction<Role[]>)=>{
        state.roles=action.payload;
        state.status='succeeded';
        state.error=null
    },
    setLoading: (state) => {
        state.status = 'loading';
        state.error = null;
      },
      setError: (state, action: PayloadAction<string>) => {
        state.status = 'failed';
        state.error = action.payload;
      },
      setTabConfiguration:(state,action:PayloadAction<TabGetConfiguration[]>)=>{
        state.tabconfiguration=action.payload;
        state.status='succeeded';
        state.error=null;
      }
}
})

export const {setrole,setLoading,setError,setTabConfiguration} = rolesSlice.actions;
export default rolesSlice.reducer;